export default __webpack_public_path__ + "static/media/728.7ff81fcd.png";